import PropTypes from 'prop-types';
import './TimelinePagination.css';

/**
 * Timeline pagination controls component
 * Shows a simple loading spinner when pagination is active
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isLoadingOlder - Whether older messages are being loaded
 * @param {boolean} props.isLoadingNewer - Whether newer messages are being loaded  
 * @returns {JSX.Element} Timeline pagination loading indicator
 */
const TimelinePagination = ({
  isLoadingOlder,
  isLoadingNewer,
}) => {
  // Show spinner if loading in either direction
  if (!isLoadingOlder && !isLoadingNewer) {
    return null;
  }

  return (
    <div className="timeline-pagination">
      <div className="timeline-pagination__loading">
        <div className="timeline-pagination__spinner" />
        <span>Loading messages...</span>
      </div>
    </div>
  );
};

TimelinePagination.propTypes = {
  isLoadingOlder: PropTypes.bool.isRequired,
  isLoadingNewer: PropTypes.bool.isRequired,
};

export default TimelinePagination;